(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-chromecast"] = factory(require("mggp-player"));
	else
		root["mggp-vendor-chromecast"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-vendor-chromecast.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-vendor-chromecast.js":
/*!***************************************!*\
  !*** ./src/mggp-vendor-chromecast.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class MggpVendorChromecast
 */
var MggpVendorChromecast = function (_Vendor) {
	_inherits(MggpVendorChromecast, _Vendor);

	_createClass(MggpVendorChromecast, null, [{
		key: 'canPlay',
		value: function canPlay() {
			return chrome.cast;
		}
	}, {
		key: 'priority',
		get: function get() {
			return 0;
		}
	}, {
		key: 'mimeTypes',
		get: function get() {
			return ['cast'];
		}
	}]);

	function MggpVendorChromecast() {
		var _ref;

		_classCallCheck(this, MggpVendorChromecast);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var _this = _possibleConstructorReturn(this, (_ref = MggpVendorChromecast.__proto__ || Object.getPrototypeOf(MggpVendorChromecast)).call.apply(_ref, [this].concat(args)));

		_this._lastVolume = _this.player.get('volume') || 60;
		_this._media = null;
		_this._onTimeUpdate = _this._onTimeUpdate.bind(_this);
		return _this;
	}

	_createClass(MggpVendorChromecast, [{
		key: 'load',
		value: function load(src, videoInfo, options) {
			this._media = this.player.get('chromecastMedia');
			if (this._media) {
				this._media.addUpdateListener(this._onMediaStatus.bind(this));
				this.player.on('player:timeUpdate', this._onTimeUpdate);
				this.player.set('duration', this._media.media.duration);
				this.player.set('position', this._media.currentTime);
				this.setVolume(this.player.get('volume'), this.player.get('muted'));
			} else {
				this._onMediaError();
			}
		}
	}, {
		key: 'setQuality',
		value: function setQuality(newBitrate) {
			if (newBitrate == -1) {
				//auto quality
				var src = this.player.get('src').replace('.cast', '');
				this.player.emit('chromecastQualityChange', src);
				this.player.set('quality', -1);
			} else {
				var bitrates = this.player.get('hlsBitrates');
				if (bitrates && bitrates.length > 1) {
					var bitrate;
					for (var i = 0, l = bitrates.length; i < l; ++i) {
						try {
							bitrate = parseInt(bitrates[i].name);
						} catch (error) {}
						if (newBitrate === bitrate) {
							this.player.emit('chromecastQualityChange', bitrates[i].url[0]);
							this.player.set('quality', newBitrate);
							break;
						}
					}
				}
			}
		}
	}, {
		key: 'setAudioTrack',
		value: function setAudioTrack(index) {
			if (this._media && this._media.media && this._media.media.contentId) {
				var src = this._media.media.contentId;
				var audioTrack = this.player.get('audioTrack');

				var i, l;
				var bitrates = this.player.get('hlsBitrates');
				if (bitrates) {
					for (i = 0, l = bitrates.length; i < l; ++i) {
						bitrates[i].url[0] = this._modifySrc(bitrates[i].url[0], audioTrack, index);
					}
				}

				//modify main playlist src
				this.player.set('src', this._modifySrc(this.player.get('src'), audioTrack, index));
				this.player.set('audioTrack', index);

				//change audio via quality changing
				var quality = this.player.get('quality');
				this.setQuality(quality);
			}
		}
	}, {
		key: '_modifySrc',
		value: function _modifySrc(src, currentIdx, newIdx) {
			if (src && src.indexOf('/a/') != -1) {
				src = src.replace('/a/' + currentIdx, '/a/' + newIdx);
			}
			return src;
		}
	}, {
		key: '_setState',
		value: function _setState(state) {
			this.set('state', state);
			this.emit('stateChange', state);
		}
	}, {
		key: '_onMediaStatus',
		value: function _onMediaStatus(alive) {
			if (!this._media) {
				return;
			}

			switch (this._media.playerState) {
				case 'IDLE':
					if (this._media.idleReason === 'FINISHED') {
						this._setState(0);
					}
					break;
				case 'BUFFERING':
					this._isBuffering = true;
					// this._setState(3);
					this.emit('bufferingStart');
					break;
				case 'PAUSED':
					this._setState(2);
					break;
				case 'PLAYING':
					if (this._isBuffering) {
						this._isBuffering = false;
						this.emit('bufferingEnd');
					}
					this._setState(1);
					break;
				default:
			}
		}
	}, {
		key: '_onTimeUpdate',
		value: function _onTimeUpdate() {
			if (!this._media) {
				return;
			}
			this.player.set('position', this._media.getEstimatedTime());
		}
	}, {
		key: '_onError',
		value: function _onError(error) {
			this.emit('error', error);
		}
	}, {
		key: '_onMediaError',
		value: function _onMediaError(error) {
			this._setState(5);
			this.emit('mediaError');
		}
	}, {
		key: '_command',
		value: function _command(name) {
			var request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var onDone = arguments[2];
			var onFail = arguments[3];

			if (!this._media) {
				return;
			}
			this._media[name](request, onDone ? onDone.bind(this) : null, onFail ? onFail.bind(this) : this._onError.bind(this));
		}
	}, {
		key: 'play',
		value: function play() {
			this._command('play');
		}
	}, {
		key: 'pause',
		value: function pause() {
			this._command('pause');
		}
	}, {
		key: 'togglePlayPause',
		value: function togglePlayPause() {
			this._command(this.player.get('state') === 1 ? 'pause' : 'play');
		}
	}, {
		key: 'seekTo',
		value: function seekTo(time) {
			var _this2 = this;

			var request = new chrome.cast.media.SeekRequest();
			request.currentTime = time;
			this._setState(4);
			this.emit('mediaSeekStart');
			this._command('seek', request, function () {
				_this2.emit('mediaSeekEnd');
			});
		}
	}, {
		key: 'setVolume',
		value: function setVolume(level, mute) {
			var _this3 = this;

			if (null !== level) {
				this._lastVolume = level;
			}
			if (undefined === mute) {
				mute = false;
			}
			level /= 100;
			this._command('setVolume', new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(level, mute)), function () {
				_this3.player.set('volume', _this3._media.volume.level * 100);
				_this3.player.set('muted', _this3._media.volume.muted);
			});
		}
	}, {
		key: 'mute',
		value: function mute() {
			this.setVolume(null, true);
		}
	}, {
		key: 'unMute',
		value: function unMute() {
			this.setVolume(this._lastVolume, false);
		}
	}, {
		key: 'stop',
		value: function stop() {
			this._command('stop');
			this.dispose();
		}
	}, {
		key: 'dispose',
		value: function dispose() {
			this.player.off('player:timeUpdate', this._onTimeUpdate);
			this._media = null;
		}
	}]);

	return MggpVendorChromecast;
}(_mggpPlayer.Vendor);

exports.default = MggpVendorChromecast;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});